import { memo } from 'react';
import styles from './ThemedFallback.module.css';

export interface ThemedFallbackProps {
  /**
   * Type of fallback:
   * - 'event': Full gradient background (for event cards without images)
   * - 'service': Short colored bar (for service cards without images)
   */
  type: 'event' | 'service';
  /** Additional CSS class */
  className?: string;
}

/**
 * ThemedFallback displays a themed gradient/bar when no image is available.
 *
 * For events: Shows full area gradient matching the brand accent color.
 * For services: Shows a 24px height colored bar at top of card.
 */
function ThemedFallbackComponent({
  type,
  className = '',
}: ThemedFallbackProps) {
  return (
    <div
      className={`${styles.fallback} ${styles[type]} ${className}`.trim()}
      role="presentation"
      data-testid={`themed-fallback-${type}`}
    />
  );
}

export const ThemedFallback = memo(ThemedFallbackComponent);
